import React, { useState, useEffect } from 'react';
import LayoutLoginOutbuild from '../../components/LayoutLoginOutbuild';
import { Redirect, useHistory } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import CompanyOptions from './companyOptions';
import { useDispatch, useSelector } from 'react-redux';
import { stateActions } from '../../redux/actions/stateActions';
import useProjects from '../project/hooks/useProjects';
import './index.scss';
import {
  getCompaniesByUser,
  getSessionToken
} from './companyOptions/companyOptions.helpers';

function SelectCompanyView(props) {
  const { t } = props;
  const dispatch = useDispatch();
  const projectState = useSelector((state) => state.projectState);
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const { getProjectsLoad } = useProjects({ dispatch, projectState });
  const authToken = localStorage.getItem('authToken');

  useEffect(() => {
    const getCompany = async () => {
      if (!authToken) return;
      const MIN_COMPANY = 1;
      const response = await getCompaniesByUser();
      if (response.length === MIN_COMPANY) {
        await getSessionToken(response[0].companyId);
        await getProjectsLoad();
        history.push('/projects');
      } else {
        setVisible(true);
      }
    };
    getCompany();
  }, [authToken]);

  const signed = localStorage.getItem('signed');
  if (!signed) {
    return <Redirect to="/login" />;
  }

  const sessionToken = sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    return <Redirect to="/projects" />;
  }

  const logout = (e) => {
    e.preventDefault();
    dispatch(stateActions.clearAllStoreData());
    localStorage.clear();
    sessionStorage.clear();
    history.push('/login');
  };

  const renderSelectCompanyView = (
    <div>
      <LayoutLoginOutbuild title={t('selectOrganization.title')}>
        <div className="SelectCompanyView__container">
          <div className="SelectCompanyView__description">
            {t('selectOrganization.description')}
          </div>
          <CompanyOptions dark={false} />
          <div className="SelectCompanyView__logout">
            <a onClick={logout}>{t('selectOrganization.logout')}</a>
          </div>
        </div>
      </LayoutLoginOutbuild>
    </div>
  );

  return visible ? renderSelectCompanyView : null;
}

export default withTranslation()(SelectCompanyView);
